<template>
  <path
    d="M4 7.00024C4 6.45024 4.45 6.00024 5 6.00024H21C21.55 6.00024 22 5.55024 22 5.00024C22 4.45024 21.55 4.00024 21 4.00024H4C2.9 4.00024 2 4.90024 2 6.00024V17.0002H1.5C0.67 17.0002 0 17.6702 0 18.5002C0 19.3302 0.67 20.0002 1.5 20.0002H14V17.0002H4V7.00024ZM23 8.00024H17C16.45 8.00024 16 8.45024 16 9.00024V19.0002C16 19.5502 16.45 20.0002 17 20.0002H23C23.55 20.0002 24 19.5502 24 19.0002V9.00024C24 8.45024 23.55 8.00024 23 8.00024ZM22 17.0002H18V10.0002H22V17.0002Z"
  />
</template>
